import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import DOMPurify from 'dompurify';
import { CardsBlockCss } from '../../../styles';
import { ProfessionCardProps } from '@/types';
import { buildImageUrl } from '@/api/buildImageUrl';
import Loader from '../loaderAndError/Loader';

/**
 * 🧩 Componente ProfessionCard
 * Tarjeta para mostrar una profesión con imagen, nombre y descripción.
 * Hace toda la tarjeta clicable para navegar a la lista de profesionales.
 */
const ProfessionCard: React.FC<ProfessionCardProps> = ({ profesion }) => {

  const [imageLoaded, setImageLoaded] = useState(false);

  // Para posibles registros en un buscador global (similar a SeccionCard)
  useEffect(() => {
    // Aquí podrías registrar la profesión en un contexto de búsqueda si quieres
  }, []);


return (
  <div className={`${CardsBlockCss.profesion} rounded-2xl overflow-hidden min-h-48 relative`}>
    <Link
      to={`/profesionales/${profesion.nombre_profesion}`}
      className="relative block w-full h-full"
    >
      {/* Loader mientras carga la imagen */}
      {!imageLoaded && (
        <div className="absolute inset-0 flex justify-center items-center bg-gray-200 z-10">
          <Loader />
        </div>
      )}

      {/* Imagen de la profesión */}
      <img
        src={buildImageUrl(profesion.imagen_url)}
        alt={profesion.nombre_profesion}
        className={`transition-all duration-300 ease-in-out w-full h-full object-cover ${
          imageLoaded ? "opacity-100" : "opacity-0"
        }`}
        onLoad={() => setImageLoaded(true)}
      />

      {/* Nombre */}
      <div className={`${CardsBlockCss.nombreProfesion} p-2`}>
        <h2 className="text-sm md:text-[18px] font-semibold text-center">
          {profesion.nombre_profesion}
        </h2>
      </div>

      {/* Descripción */}
      <div className={`${CardsBlockCss.descripcionProfesion} p-4 custom-scrollbar`}>
        <p
          className="text-sm text-start leading-relaxed"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(
              (profesion.descripcion ?? "").replace(/(\n|\r)/g, "<br/>")
            ),
          }}
        />
      </div>
    </Link>
  </div>
);

};

export default ProfessionCard;
